<template>
  <!-- 统计卡片容器 -->
  <div class="statistic-container">
    <!-- 宝付数据卡片 -->
    <div class="stat-card">
      <div class="card-header">
        <span class="card-title">宝付数据-灏天</span>
      </div>
      <div class="card-body">
        <div class="stat-grid">
          <div class="stat-item">
            <span class="stat-label">总订购数</span>
            <span class="stat-value">{{ baoFuData.totalAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ baoFuData.totalSef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总退订数</span>
            <span class="stat-value">{{ baoFuData.totalCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总退订率</span>
            <span class="stat-value">{{ calculateRate(baoFuData.totalCal, baoFuData.totalAdd) }}%</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月订购数</span>
            <span class="stat-value">{{ baoFuData.monthAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ baoFuData.monthSef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月退订数</span>
            <span class="stat-value">{{ baoFuData.monthCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月退订率</span>
            <span class="stat-value">{{ calculateRate(baoFuData.monthCal, baoFuData.monthAdd) }}%</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日订购数</span>
            <span class="stat-value">{{ baoFuData.dayAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ baoFuData.daySef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日退订数</span>
            <span class="stat-value">{{ baoFuData.dayCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日退订率</span>
            <span class="stat-value">{{ calculateRate(baoFuData.dayCal, baoFuData.dayAdd) }}%</span>
          </div>
        </div>
        <!-- 查询汇总（按时间筛选）- 宝付 -->
        <div v-if="hasDateFilter" class="summary-section">
          <div class="summary-title">查询汇总（按时间筛选）</div>
          <div class="summary-items">
            <div class="summary-item">
              <span class="summary-label">订购数</span>
              <span class="summary-value">{{ summaryData.baoFuAdd }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">自发展订购数</span>
              <span class="summary-value">{{ summaryData.baoFuSelf }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">退订数</span>
              <span class="summary-value">{{ summaryData.baoFuCal }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">退订率</span>
              <span class="summary-value">{{ calculateRate(summaryData.baoFuCal, summaryData.baoFuAdd) }}%</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 宝付数据卡片 -->
    <div class="stat-card">
      <div class="card-header">
        <span class="card-title">宝付数据-邦远</span>
      </div>
      <div class="card-body">
        <div class="stat-grid">
          <div class="stat-item">
            <span class="stat-label">总订购数</span>
            <span class="stat-value">{{ bBaoFuData.totalAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ bBaoFuData.totalSef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总退订数</span>
            <span class="stat-value">{{ bBaoFuData.totalCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总退订率</span>
            <span class="stat-value">{{ calculateRate(bBaoFuData.totalCal, bBaoFuData.totalAdd) }}%</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月订购数</span>
            <span class="stat-value">{{ bBaoFuData.monthAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ bBaoFuData.monthSef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月退订数</span>
            <span class="stat-value">{{ bBaoFuData.monthCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月退订率</span>
            <span class="stat-value">{{ calculateRate(bBaoFuData.monthCal, bBaoFuData.monthAdd) }}%</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日订购数</span>
            <span class="stat-value">{{ bBaoFuData.dayAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ bBaoFuData.daySef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日退订数</span>
            <span class="stat-value">{{ bBaoFuData.dayCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日退订率</span>
            <span class="stat-value">{{ calculateRate(bBaoFuData.dayCal, bBaoFuData.dayAdd) }}%</span>
          </div>
        </div>
        <!-- 查询汇总（按时间筛选）- 宝付 -->
        <div v-if="hasDateFilter" class="summary-section">
          <div class="summary-title">查询汇总（按时间筛选）</div>
          <div class="summary-items">
            <div class="summary-item">
              <span class="summary-label">订购数</span>
              <span class="summary-value">{{ summaryData.bBaoFuAdd }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">自发展订购数</span>
              <span class="summary-value">{{ summaryData.bBaoFuSelf }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">退订数</span>
              <span class="summary-value">{{ summaryData.bBaoFuCal }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">退订率</span>
              <span class="summary-value">{{ calculateRate(summaryData.bBaoFuCal, summaryData.bBaoFuAdd) }}%</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 汇付数据卡片 -->
    <div class="stat-card">
      <div class="card-header">
        <span class="card-title">汇付数据</span>
      </div>
      <div class="card-body">
        <div class="stat-grid">
          <div class="stat-item">
            <span class="stat-label">总订购数</span>
            <span class="stat-value">{{ huiFuData.totalAdd }}</span>
          </div>

          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ huiFuData.totalSef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总退订数</span>
            <span class="stat-value">{{ huiFuData.totalCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">总退订率</span>
            <span class="stat-value">{{ calculateRate(huiFuData.totalCal, huiFuData.totalAdd) }}%</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月订购数</span>
            <span class="stat-value">{{ huiFuData.monthAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ huiFuData.monthSef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月退订数</span>
            <span class="stat-value">{{ huiFuData.monthCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">月退订率</span>
            <span class="stat-value">{{ calculateRate(huiFuData.monthCal, huiFuData.monthAdd) }}%</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日订购数</span>
            <span class="stat-value">{{ huiFuData.dayAdd }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">自发展订购数</span>
            <span class="stat-value">{{ huiFuData.daySef }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日退订数</span>
            <span class="stat-value">{{ huiFuData.dayCal }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">日退订率</span>
            <span class="stat-value">{{ calculateRate(huiFuData.dayCal, huiFuData.dayAdd) }}</span>
          </div>
        </div>
        <!-- 查询汇总（按时间筛选）- 汇付 -->
        <div v-if="hasDateFilter" class="summary-section">
          <div class="summary-title">查询汇总（按时间筛选）</div>
          <div class="summary-items">
            <div class="summary-item">
              <span class="summary-label">订购数</span>
              <span class="summary-value">{{ summaryData.huiFuAdd }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">自发展订购数</span>
              <span class="summary-value">{{ summaryData.huiFuSelf }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">退订数</span>
              <span class="summary-value">{{ summaryData.huiFuCal }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">退订率</span>
              <span class="summary-value">{{ calculateRate(summaryData.huiFuCal, summaryData.huiFuAdd) }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import {defineProps, computed} from 'vue';

// 定义数据类型
interface StatisticResult {
  totalAdd: number,
  totalSef: number,
  totalCal: number,
  monthAdd: number,
  monthSef: number,
  motnCal: number,
  dayAdd: number,
  daySef: number,
  dayCal: number,

  htotalAdd: number,
  htotalSef: number,
  htotalCal: number,
  hmonthAdd: number,
  hmonthSef: number,
  hmotnCal: number,
  hdayAdd: number,
  hdaySef: number,
  hdayCal: number,

  htotalCalLV: number,
  monthAddNotHt: number,
  totalCalNotHt: number,
  dayAddNotHt: number,
  daySefNotHt: number,
  monthSefNotHt: number,
  totalSefNotHt: number,
  dayCalNotHt: number,
  totalAddNotHt: number,
  motnCalNotHt: number,
}

interface GroupedItem {
  totalAdd: number;
  totalSef: number;
  totalCal: number;
  monthAdd: number;
  monthSef: number;
  monthCal: number;
  dayAdd: number;
  daySef: number;
  dayCal: number;
}

interface SummaryData {
  baoFuAdd: number;
  baoFuCal: number;
  baoFuSelf: number;
  bBaoFuAdd: number;
  bBaoFuCal: number;
  bBaoFuSelf: number;
  huiFuAdd: number;
  huiFuSelf: number;
  huiFuCal: number;
}

// 定义 Props 接收父组件传来的数据
const props = defineProps<{
  groupedData: StatisticResult | Record<string, any>;
  summaryData: SummaryData;
  hasDateFilter: boolean;
}>();

// 汇付数据（前缀 h 开头）
const huiFuData = computed<GroupedItem>(() => {
  const data = props.groupedData || {};
  return {
    totalAdd: data.htotalAdd || 0,
    totalSef: data.htotalSef || 0,
    totalCal: data.htotalCal || 0,
    monthAdd: data.hmonthAdd || 0,
    monthSef: data.hmonthSef || 0,
    monthCal: data.hmotnCal || 0,
    dayAdd: data.hdayAdd || 0,
    daySef: data.hdaySef || 0,
    dayCal: data.hdayCal || 0
  };
});

// 宝付数据灏天（无前缀）
const baoFuData = computed<GroupedItem>(() => {
  const data = props.groupedData || {};
  return {
    totalAdd: data.totalAdd || 0,
    totalSef: data.totalSef || 0,
    totalCal: data.totalCal || 0,
    monthAdd: data.monthAdd || 0,
    monthSef: data.monthSef || 0,
    monthCal: data.motnCal || 0,
    dayAdd: data.dayAdd || 0,
    daySef: data.daySef || 0,
    dayCal: data.dayCal || 0
  };
});

// 宝付数据邦远（无前缀）
const bBaoFuData = computed<GroupedItem>(() => {
  const data = props.groupedData || {};
  return {
    totalAdd: data.totalAddNotHt || 0,
    totalSef: data.totalSefNotHt || 0,
    totalCal: data.totalCalNotHt || 0,
    monthAdd: data.monthAddNotHt|| 0,
    monthSef: data.monthSefNotHt || 0,
    monthCal: data.motnCalNotHt || 0,
    dayAdd: data.dayAddNotHt || 0,
    daySef: data.daySefNotHt || 0,
    dayCal: data.dayCalNotHt || 0
  };
});

// 计算退订率
const calculateRate = (cal: number, add: number): string => {
  if (add === 0) return '0.00';
  return ((cal / add) * 100).toFixed(2);
};
</script>

<style scoped>
.statistic-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

}

.stat-card {
  margin: 20px;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.card-header {
  padding: 16px 20px;
  background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
}

/* 汇总卡片使用不同的背景色 */
.summary-card .card-header {
  background: linear-gradient(135deg, #E6A23C 0%, #F56C6C 100%);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.card-body {
  padding: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

/* 汇总卡片的网格布局 */
.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: #e8f4ff;
  transform: translateY(-2px);
}

.stat-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.tb_column_content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 10px 0;
}

/* 查询汇总区域样式 */
.summary-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e4e7ed;
}

.summary-title {
  font-size: 14px;
  font-weight: 600;
  color: #E6A23C;
  margin-bottom: 12px;
}

.summary-items {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: #fff7e6;
  border-radius: 6px;
  border-left: 3px solid #E6A23C;
}

.summary-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: #E6A23C;
}
</style>
